/* =========================================================
   ALLURECART — storefront behaviour
   Talks to the real Shopify cart (/cart.js, /cart/add.js,
   /cart/change.js). Config comes from window.ACConfig,
   written by layout/theme.liquid from theme settings.
   ========================================================= */
(function () {
  'use strict';

  var CFG = window.ACConfig || {};
  var cart = null;                 // last cart.js payload
  var busy = false;

  /* ---------- money ----------
     Everything Shopify hands us (cart.js, line prices, totals) arrives in the
     SHOPPER'S currency. The thresholds typed into Theme settings are plain numbers
     in the SHOP'S currency. Comparing the two directly meant a Swedish shopper hit
     a "199" tier at 199 SEK — about $21 — and walked off with the mystery lighter.
     Shopify publishes the market's conversion rate; every threshold goes through it. */
  function fxRate() {
    var s = window.Shopify;
    var r = s && s.currency && s.currency.rate ? parseFloat(s.currency.rate) : 1;
    return isFinite(r) && r > 0 ? r : 1;
  }
  function activeCurrency() {
    var s = window.Shopify;
    return (s && s.currency && s.currency.active) || CFG.shopCurrency || null;
  }
  /* A converted threshold like 631.75 reads like a mistake. Round it to a number a
     human would have written: nearest 100 above 1000 units, nearest 10 above 100. */
  function tidy(cents) {
    if (CFG.roundThresholds === false) return cents;
    var units = cents / 100;
    var step = units >= 1000 ? 10000 : units >= 100 ? 1000 : 100;
    return Math.round(cents / step) * step;
  }
  function toShopper(cents) { return tidy(Math.round(Number(cents || 0) * fxRate())); }

  /* Convert every money threshold in the config exactly once, at boot. */
  function localiseConfig() {
    var s = window.Shopify;
    var haveRate = !!(s && s.currency && s.currency.rate);
    var active = activeCurrency();
    /* Foreign currency but no published rate: we cannot know what the thresholds are
       worth. Give nothing away rather than guess — a wrong guess ships free stock. */
    CFG.fxUnknown = !!(active && CFG.shopCurrency && active !== CFG.shopCurrency && !haveRate);

    if (fxRate() !== 1) {
      CFG.freeShipThreshold = toShopper(CFG.freeShipThreshold);
      (CFG.rewards || []).forEach(function (r) { r.threshold = toShopper(r.threshold); });
      (CFG.gifts || []).forEach(function (g) { g.threshold = toShopper(g.threshold); });
      if (CFG.checkoutRules && CFG.checkoutRules.minOrder) {
        CFG.checkoutRules.minOrder = toShopper(CFG.checkoutRules.minOrder);
      }
    }
    /* In the home market Liquid has already printed these correctly, and this script
       is deferred — rewriting the text afterwards only nudges the announcement bar
       wider ("$79" -> "$79.00") once the page is painted. That bar sits above
       everything, so the whole page shifts down with it. Measured on the live store:
       +3 characters, at the very top of the document. Leave it alone unless the
       shopper is actually in another currency. */
    if (fxRate() === 1 && !CFG.fxUnknown) return;

    var free = fmt(CFG.freeShipThreshold || 0);
    $$('[data-ac-freeship]').forEach(function (el) { el.textContent = free; });
    var tick = $('[data-ac-ticker]');
    if (tick) {
      var tpl = tick.getAttribute('data-ac-ticker') || '';
      if (tpl.indexOf('{threshold}') > -1) tick.textContent = tpl.split('{threshold}').join(free);
    }
  }

  /* Learn the market's money shape from a sample Shopify rendered itself.
     Intl was close but not the same: it prints HUF with two decimals because ISO
     4217 says so, while Shopify — and Hungary — use whole forints. Copying
     Shopify's own output sidesteps every per-currency convention argument. */
  var moneyShape = null;
  function shape() {
    if (moneyShape !== null) return moneyShape;
    moneyShape = false;
    var s = CFG.moneySample;
    if (typeof s !== 'string' || !s) return moneyShape;
    /* Some money formats carry the symbol as an entity — "&#8377;{{amount}}" for the
       rupee. Those digits belong to the symbol, not the number, so decode first. */
    if (s.indexOf('&') > -1) {
      try { var ta = document.createElement('textarea'); ta.innerHTML = s; s = ta.value; } catch (e) {}
    }
    /* Take the longest numeric run: the amount, never a stray digit in a symbol. */
    var re = /\d[\d.,   '’]*\d|\d/g, m = null, mm;
    while ((mm = re.exec(s))) {
      if (!m || mm[0].replace(/\D/g, '').length > m[0].replace(/\D/g, '').length) m = mm;
    }
    if (!m) return moneyShape;
    var num = m[0];
    var digits = num.replace(/\D/g, '');
    if (digits.length < 4) return moneyShape;
    var decimals = digits.length >= 6 ? 2 : 0;      // sample is 1234.56
    var decSep = '.', groupSep = '';
    if (decimals === 2) {
      decSep = num.charAt(num.length - 3);
      var rest = num.slice(0, num.length - 3).replace(/\d/g, '');
      groupSep = rest.charAt(0) || '';
    } else {
      groupSep = num.replace(/\d/g, '').charAt(0) || '';
    }
    moneyShape = {
      prefix: s.slice(0, m.index),
      suffix: s.slice(m.index + num.length),
      decimals: decimals,
      decSep: decSep,
      groupSep: groupSep
    };
    return moneyShape;
  }

  function fmt(cents) {
    var v0 = Number(cents || 0) / 100;
    var sh = shape();
    if (sh) {
      var parts = v0.toFixed(sh.decimals).split('.');
      if (sh.groupSep) parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sh.groupSep);
      return sh.prefix + (parts.length > 1 ? parts[0] + sh.decSep + parts[1] : parts[0]) + sh.suffix;
    }
    var fmtStr = CFG.moneyFormat || '${{amount}}';
    var v = (cents / 100);
    function withComma(n, dec) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    /* Shopify has more money_format placeholders than most themes handle. Missing
       amount_with_space_separator is why a Swedish price rendered as the literal
       text "{{amount_with_space_separator}} kr". */
    function grouped(dec, groupSep, decSep) {
      var parts = v.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, groupSep);
      return parts.length > 1 ? parts[0] + decSep + parts[1] : parts[0];
    }
    return fmtStr
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, grouped(0, '.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, grouped(0, ' ', ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, grouped(2, '.', ','))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, grouped(2, ' ', ','))
      .replace(/\{\{\s*amount_with_period_and_space_separator\s*\}\}/g, grouped(2, ' ', '.'))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, grouped(2, "'", '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withComma(v, 0))
      .replace(/\{\{\s*amount\s*\}\}/g, withComma(v, 2));
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- toast ---------- */
  var toastT;
  function toast(msg) {
    if (drawerOpen()) return;                       // the drawer already shows the change
    var t = $('#ac-toast'); if (!t) return;
    $('#ac-toastMsg').textContent = msg;
    t.classList.add('on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove('on'); }, 2100);
  }

  /* ---------- cart api ---------- */
  function getCart() {
    return fetch(CFG.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function addItems(items) {
    return fetch(CFG.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); });
  }
  /* update.js answers with the WHOLE cart, so nothing that goes through it needs a
     follow-up GET — and it takes absolute quantities for every variant at once, which
     is what lets one request carry a whole burst of taps. Addressing lines by variant
     id is only safe because no line in this theme carries line-item properties.

     change.js, which addresses a single line by key, is deliberately not used: one
     line per request is what made bursts race in the first place. */
  function updateCart(updates) {
    return fetch((CFG.routes.cart_update_url || (CFG.routes.cart_url + '/update')) + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- optimistic cart ----------
     Every tap used to wait for the network before anything on screen moved: the
     drawer dimmed to 45%, then a second or two later the new numbers appeared.
     The shopper reads that pause as the site thinking.

     Nothing here changes what the cart settles on — the server's answer still
     overwrites everything a moment later. It only changes WHEN the shopper sees
     the change: we work out the cart the server is about to hand back, paint that
     immediately, and let the request catch up. */

  function unitFinal(li) {
    if (typeof li.final_price === 'number') return li.final_price;
    if (li.quantity > 0 && typeof li.final_line_price === 'number') return li.final_line_price / li.quantity;
    return li.price || 0;
  }
  function unitOriginal(li) {
    if (typeof li.original_price === 'number') return li.original_price;
    if (li.quantity > 0 && typeof li.original_line_price === 'number') return li.original_line_price / li.quantity;
    return unitFinal(li);
  }
  function cloneLine(li, qty) {
    var o = {}, k;
    for (k in li) o[k] = li[k];
    o.quantity = qty;
    o.final_line_price = unitFinal(li) * qty;
    o.line_price = o.final_line_price;
    o.original_line_price = unitOriginal(li) * qty;
    return o;
  }
  function cloneCart(c) {
    var o = {}, k;
    for (k in c) o[k] = c[k];
    o.items = c.items.slice();
    return o;
  }
  function recount(c) {
    var n = 0, tot = 0, orig = 0;
    c.items.forEach(function (li) {
      n += li.quantity;
      tot += li.final_line_price || 0;
      orig += (li.original_line_price != null ? li.original_line_price : li.final_line_price) || 0;
    });
    c.item_count = n;
    c.total_price = tot;
    c.original_total_price = orig;
    c.items_subtotal_price = tot;
    return c;
  }
  function provisional(id, title, price, image, variantTitle, productId) {
    /* A line the cart does not have yet. The key is deliberately not a real one —
       the server's own line replaces this before any button on it can be used. */
    return {
      key: 'ac-pending:' + id, id: id, variant_id: id, product_id: productId || 0,
      quantity: 1, product_title: title, title: title,
      variant_title: variantTitle || null, image: image || null,
      price: price, final_price: price, original_price: price,
      final_line_price: price, line_price: price, original_line_price: price
    };
  }
  function predictQty(c, key, qty) {
    var next = cloneCart(c);
    next.items = [];
    c.items.forEach(function (li) {
      if (li.key !== key) { next.items.push(li); return; }
      if (qty > 0) next.items.push(cloneLine(li, qty));
    });
    return recount(next);
  }
  /* Description of a line we are about to add, for the parts the shopper actually
     looks at: name, thumbnail, price. Drawn from the same theme settings that
     rendered the button they just tapped. */
  function lineMeta(variantId) {
    var hit = null;
    (CFG.upsells || []).forEach(function (p) {
      if (p.variant === variantId) hit = { pid: p.id, title: p.title, price: p.price, image: p.image };
    });
    (CFG.addons || []).forEach(function (a) {
      if (a.variant === variantId) hit = { pid: a.id, title: a.title, price: a.price, image: a.image };
    });
    return hit;
  }
  function predictAdd(c, variantId, qty, meta) {
    var next = cloneCart(c), found = -1;
    next.items.forEach(function (li, i) { if ((li.variant_id || li.id) === variantId) found = i; });
    if (found > -1) {
      next.items[found] = cloneLine(next.items[found], next.items[found].quantity + qty);
      return recount(next);
    }
    var m = meta || lineMeta(variantId);
    /* Unknown product: predict nothing rather than guess wrong. The server adds it
       a moment later and the only cost is that one line arrives late. */
    if (!m) return recount(next);
    var line = provisional(variantId, m.title || '', m.price || 0, m.image, m.variantTitle, m.pid);
    line.quantity = qty;
    line.final_line_price = line.line_price = line.original_line_price = (m.price || 0) * qty;
    next.items.push(line);
    return recount(next);
  }
  /* Mirror reconcile()'s rules locally, so the free gift and the protection fee land
     on the same tap that earns them instead of one round trip later. Crossing a
     reward threshold is the best moment in this cart; it should not lag. */
  function predictAuto(c) {
    var next = cloneCart(c);
    var sub = qualifyingSubtotal(next);
    var want = {};
    if (!CFG.fxUnknown) {
      (CFG.gifts || []).forEach(function (g) {
        if (g.variant && sub >= g.threshold) want[g.variant] = { title: g.label, price: 0 };
      });
    }
    if (CFG.protection && CFG.protection.variant && protectOn() && cartShape(next).coreCount > 0) {
      want[CFG.protection.variant] = {
        title: CFG.protection.title || 'Shipping Protection',
        price: CFG.protection.price || 0
      };
    }
    var managed = {};
    (CFG.gifts || []).forEach(function (g) { if (g.variant) managed[g.variant] = true; });
    if (CFG.protection && CFG.protection.variant) managed[CFG.protection.variant] = true;

    next.items = next.items.filter(function (li) {
      var id = li.variant_id || li.id;
      return !managed[id] || want[id];
    });
    Object.keys(want).forEach(function (idStr) {
      var id = Number(idStr);
      var has = next.items.some(function (li) { return (li.variant_id || li.id) === id; });
      if (!has) next.items.push(provisional(id, want[id].title, want[id].price, null));
    });
    return recount(next);
  }
  /* ---------- one wish, one request ----------

     Two earlier designs failed here, and both failed for the same underlying reason:
     a tap was turned into a REQUEST, so several requests could describe several
     different moments and their replies fought over the screen.

       1. One request per tap, run in parallel — replies landed out of order, so
          removing two lighters quickly brought the second one back.
       2. Same, but serialised, and only the last reply painted — better, yet the
          gift and the protection fee are settled by `reconcile`, a SECOND round trip
          that runs after the first reply is already on screen. Remove a lighter that
          drops the cart under a gift threshold and the first reply is a cart with the
          lighter gone but the gift still in it. Painting that brings the gift back;
          reconcile then removes it a moment later. Both replies are the latest word
          at the moment they arrive, so no freshness check can help.

     So a tap no longer makes a request. It records what the shopper WANTS, and a
     single flush turns the whole wish into one `update.js` call — which takes
     absolute quantities for the entire cart, gifts and protection fee included.

     Three things follow from that, and they are the point of the design:
       · six taps on + become one request carrying 7, not six requests
       · only ever ONE request is in flight, so replies cannot arrive out of order
       · the gift is in the same request as the lighter, so there is no second phase
         and nothing to flicker between                                              */

  var serverCart = null;   // the last cart Shopify actually confirmed
  var wish = null;         // variantId -> absolute qty still to be sent, or null
  var sending = false;
  var intents = 0;         // bumped by every tap the shopper makes

  /* The one question every reply must answer before it is allowed to paint: is the
     screen still showing what this reply describes? A request issued at page load can
     land long after the shopper has started tapping — that is not a race between taps,
     it is a reply from before the conversation started. */
  function stale(seen) { return seen !== intents || !!wish || sending; }

  /* The complete delta from what Shopify last confirmed to what is on screen.
     Recomputed from scratch on every tap, so a newer wish simply replaces the old
     one — last wish wins, by construction rather than by a race. */
  function wishFrom(target, base) {
    var had = {}, out = {}, any = false;
    ((base && base.items) || []).forEach(function (li) {
      var id = li.variant_id || li.id;
      had[id] = (had[id] || 0) + li.quantity;
    });
    var now = {};
    target.items.forEach(function (li) {
      var id = li.variant_id || li.id;
      now[id] = (now[id] || 0) + li.quantity;
    });
    Object.keys(had).forEach(function (id) { if (now[id] === undefined) now[id] = 0; });
    Object.keys(now).forEach(function (id) {
      if ((had[id] || 0) !== now[id]) { out[id] = now[id]; any = true; }
    });
    return any ? out : null;
  }

  /* The only entry point for a change the shopper asked for.

     `ensure` is the safety belt, and it is not optional decoration. The request is
     built from the PREDICTED cart, and predictAdd can only describe a line it has
     details for — a title, a price, a thumbnail. A bundled lighter ticked on the
     product page is a variant of some other product, so it is in none of the upsell
     or add-on settings, and the prediction quietly left it out. Building the request
     from that prediction meant Shopify was never told about it: the shopper ticked a
     second lighter, paid, and it was not in the order.

     So callers that know exactly what was asked for pass absolute quantities here,
     and those win over whatever the prediction managed to work out. */
  function intend(next, ensure) {
    intents++;
    paintCart(predictAuto(next));          // gifts and the fee settled locally, on the tap
    var w = wishFrom(cart, serverCart);
    if (ensure) {
      w = w || {};
      Object.keys(ensure).forEach(function (id) { w[id] = ensure[id]; });
    }
    wish = w;
    if (!wish) return Promise.resolve(cart);
    return flush();
  }

  /* Absolute quantities for a set of {id, quantity} adds, counted from what Shopify
     last confirmed — which is what update.js expects. */
  function absoluteFor(items) {
    var have = {}, out = {};
    ((serverCart && serverCart.items) || []).forEach(function (li) {
      var id = li.variant_id || li.id;
      have[id] = (have[id] || 0) + li.quantity;
    });
    items.forEach(function (it) {
      if (out[it.id] === undefined) out[it.id] = have[it.id] || 0;
      out[it.id] += it.quantity;
    });
    return out;
  }

  function flush() {
    if (sending || !wish) return Promise.resolve(cart);
    var payload = wish;
    wish = null;
    sending = true;
    return updateCart(payload).then(function (c) {
      sending = false;
      if (c && c.items) serverCart = c;
      /* A tap landed while this was in flight: its wish already describes the screen,
         so send that instead of painting a cart the shopper has moved past. */
      if (wish) return flush();
      if (!c || !c.items) return reload();
      paintCart(c);
      /* Safety net only. The gift rules were applied locally and travelled in the
         payload, so this almost never has anything to do — but a server-side discount
         can move the subtotal across a threshold in a way the local guess missed. */
      var seen = intents;
      return reconcile(c).then(function (c2) {
        if (c2 !== c && !stale(seen)) { serverCart = c2; paintCart(c2); }
        return cart;
      });
    }, function () {
      sending = false;
      return wish ? flush() : reload();
    });
  }

  /* Throw away the optimistic view and take whatever Shopify says. */
  function reload() {
    var seen = intents;
    return getCart().then(function (c) {
      if (stale(seen)) return cart;          // the shopper is ahead of us again
      serverCart = c;
      paintCart(c);
      return c;
    }, function () { return cart; });
  }

  /* The checkout button is never disabled, and the drawer never dims.

     It used to be held while a request was in flight, by a counter raised on each tap
     and lowered when the reply landed. That counter leaked: two quick taps on the
     upsell rail raised it twice, and because a burst coalesces into ONE request only
     one reply ever came back to lower it. The button was left permanently
     pointer-events:none — dead to every tap, with nothing on screen to explain why.
     A counter that must be balanced across branching async paths is the wrong shape.

     What it was guarding against is real, though: tapping Checkout before the last
     update.js has landed hands Shopify a cart it has not been told about yet. So the
     tap WAITS instead of being refused — see the data-ac-checkout handler below. */
  function applyLock() {
    var d = $('#ac-drawer');
    if (!d) return;
    d.classList.remove('ac-busy');
    /* Heal a stuck inline lock left behind by the previous version of this file. */
    var go = d.querySelector('.ac-cfoot .ac-btn');
    if (go && go.style.pointerEvents) go.style.pointerEvents = '';
  }

  /* Run fn once nothing is pending. Capped, so a request that never comes back cannot
     strand the shopper on a button that appears to do nothing. */
  function whenSettled(fn) {
    if (!wish && !sending) return fn();
    var done = false, tick, cap;
    var go = function () {
      if (done) return;
      done = true;
      clearInterval(tick); clearTimeout(cap);
      fn();
    };
    tick = setInterval(function () { if (!wish && !sending) go(); }, 60);
    cap = setTimeout(go, 4000);
  }

  /* Reconcile automatic lines: free gifts by threshold, shipping protection by toggle.
     Runs one pass — gifts cost 0 so adding them can't retrigger a threshold. */
  function reconcile(c) {
    var sub = qualifyingSubtotal(c);
    var wanted = {};                                 // variantId -> qty
    if (!CFG.fxUnknown) {
      (CFG.gifts || []).forEach(function (g) {
        if (g.variant && sub >= g.threshold) wanted[g.variant] = 1;
      });
    }
    /* Shipping protection only exists alongside something to protect. This also means
       emptying the cart strips it, instead of leaving a lone $2.99 line behind. */
    if (CFG.protection && CFG.protection.variant && protectOn() && cartShape(c).coreCount > 0) {
      wanted[CFG.protection.variant] = 1;
    }

    var managed = {};
    (CFG.gifts || []).forEach(function (g) { if (g.variant) managed[g.variant] = true; });
    if (CFG.protection && CFG.protection.variant) managed[CFG.protection.variant] = true;

    /* One update.js call fixes every managed line at once — it used to be a request
       per gift plus a re-fetch, which is what made the cart feel laggy. Gifts and the
       protection fee carry no line properties, so addressing them by variant is safe. */
    var have = {};
    c.items.forEach(function (li) {
      if (managed[li.variant_id]) have[li.variant_id] = (have[li.variant_id] || 0) + li.quantity;
    });

    var updates = {}, changed = false;
    Object.keys(managed).forEach(function (id) {
      var want = wanted[id] ? 1 : 0;
      if ((have[id] || 0) !== want) { updates[id] = want; changed = true; }
    });

    if (!changed) return Promise.resolve(c);
    return updateCart(updates).then(function (c2) { return c2 && c2.items ? c2 : c; });
  }

  /* Paint what we already know first, then settle the automatic lines. The drawer
     opens on the tap, not after the network. */
  function paintCart(c) {
    cart = c;
    renderCart();
    bump();
    gateCartPage();
    applyLock();   // renderCart rewrites the footer, taking the lock with it
  }

  /* First load, and anywhere the shopper has not asked for anything yet. Every path
     that can run while a tap is pending goes through reload() instead. */
  function refresh(showDrawer) {
    if (showDrawer) openDrawer();
    /* Page load issues TWO requests: a read, then reconcile's write to settle the
       protection fee and any gift. The second can land seconds later — well after the
       shopper has opened the drawer and started removing things. Painting it then
       rewinds the cart to how it looked before they touched it, and the row under
       their finger moves, so the next tap hits the wrong lighter. That is the whole
       bug: not taps racing each other, but a reply from before they started. */
    var seen = intents;
    return getCart().then(function (c) {
      if (stale(seen)) return cart;
      serverCart = c;
      paintCart(c);
      return reconcile(c).then(function (c2) {
        if (stale(seen)) return cart;
        if (c2 && c2.items) serverCart = c2;
        if (c2 !== cart) paintCart(c2);
        return c2;
      });
    }, function (e) { throw e; });
  }

  /* ---------- shipping protection preference ---------- */
  function protectOn() {
    if (!CFG.protection || !CFG.protection.variant) return false;
    var v = null;
    try { v = localStorage.getItem('ac_protect'); } catch (e) {}
    if (v === null) return CFG.protection.defaultOn !== false;
    return v === '1';
  }
  function setProtect(on) {
    try { localStorage.setItem('ac_protect', on ? '1' : '0'); } catch (e) {}
  }

  /* ---------- badges ---------- */
  function bump() {
    var n = cart ? cart.item_count : 0;
    $$('.ac-badge').forEach(function (b) { b.textContent = n; b.dataset.n = n; });
  }

  /* ---------- drawer ---------- */
  /* Null-safe: the concierge chat only exists when it's switched on in Theme
     settings. Reading .classList off the missing node threw inside closeDrawer,
     BEFORE the line that unlocks the page — so closing the cart left the body
     stuck at overflow:hidden and nothing scrolled until a reload. */
  function isOn(sel) { var el = $(sel); return !!(el && el.classList.contains('on')); }
  function setOn(sel, on) { var el = $(sel); if (el) el.classList.toggle('on', !!on); }

  /* One place decides whether the page may scroll, so no single close path can
     leave the lock behind. */
  function syncScrollLock() {
    var locked = isOn('#ac-drawer') || isOn('#ac-modal') || isOn('#ac-chat');
    document.body.classList.toggle('ac-locked', locked);
  }

  function drawerOpen() { return isOn('#ac-drawer'); }
  function openDrawer() {
    var d = $('#ac-drawer');
    if (d) { d.classList.add('on'); d.setAttribute('aria-hidden', 'false'); }
    setOn('#ac-scrim', true);
    syncScrollLock();
  }
  function closeDrawer() {
    var d = $('#ac-drawer');
    if (d) { d.classList.remove('on'); d.setAttribute('aria-hidden', 'true'); }
    if (!isOn('#ac-chat')) setOn('#ac-scrim', false);
    syncScrollLock();
  }

  /* Subtotal that counts toward the reward ladder: everything except the
     auto-added free gifts and the shipping-protection line. */
  /* What the reward ladder measures. Order-level automatic discounts never reach
     final_line_price — they only show up in cart.total_price — so measuring lines
     alone handed out a $199 gift to someone paying $178. */
  function qualifyingSubtotal(c) {
    var skip = {};
    (CFG.gifts || []).forEach(function (g) { if (g.variant) skip[g.variant] = true; });
    if (CFG.protection && CFG.protection.variant) skip[CFG.protection.variant] = true;

    var lineSum = 0, listSum = 0, skipped = 0;
    c.items.forEach(function (li) {
      if (skip[li.variant_id]) { skipped += li.final_line_price; return; }
      lineSum += li.final_line_price;
      listSum += li.original_line_price != null ? li.original_line_price : li.final_line_price;
    });

    if (CFG.rewardBasis === 'before') return listSum;

    var total = typeof c.total_price === 'number' ? c.total_price : lineSum + skipped;
    return Math.max(0, Math.min(total - skipped, lineSum));
  }

  /* Cart makeup, used by both the protection rule and the checkout gate.
     "core" = a real product: not a free gift, not the protection fee, not a spare. */
  function cartShape(c) {
    var skip = {}, addon = {};
    (CFG.gifts || []).forEach(function (g) { if (g.variant) skip[g.variant] = true; });
    if (CFG.protection && CFG.protection.variant) skip[CFG.protection.variant] = true;
    (CFG.addons || []).forEach(function (a) { addon[a.id] = true; });
    var coreCount = 0, coreSubtotal = 0;
    (c.items || []).forEach(function (li) {
      /* /cart.js gives both `id` and `variant_id` for a line, and they agree.
         This is a security gate, so don't let it hinge on one field name —
         a payload carrying only `id` must classify the same way. */
      var vid = li.variant_id || li.id;
      if (skip[vid] || addon[li.product_id]) return;
      coreCount += li.quantity;
      coreSubtotal += li.final_line_price;
    });
    return { coreCount: coreCount, coreSubtotal: coreSubtotal };
  }

  /* Why checkout is blocked, or null when it's fine. */
  function checkoutBlock(c) {
    var r = CFG.checkoutRules || {};
    var shape = cartShape(c);
    if (r.requireProduct !== false && shape.coreCount === 0) {
      return r.message || 'Add a product to your cart before checking out.';
    }
    if (r.minOrder > 0 && shape.coreSubtotal < r.minOrder) {
      return 'Orders start at ' + fmt(r.minOrder) + '. Add ' +
             fmt(r.minOrder - shape.coreSubtotal) + ' more to check out.';
    }
    return null;
  }

  function giftIcon() {
    return '<svg viewBox="0 0 24 24"><rect x="3.5" y="8.5" width="17" height="12" rx="1.5"/>' +
      '<path d="M3.5 12.5h17M12 8.5v12"/></svg>';
  }

  function tickIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" ' +
      'stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7"/></svg>';
  }

  function shieldIcon() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
      'stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M12 3l7 3v5.2c0 4.4-2.9 8.3-7 9.8-4.1-1.5-7-5.4-7-9.8V6l7-3z"/>' +
      '<path d="M9.2 12.2l2 2 3.6-3.9"/></svg>';
  }

  function renderCart() {
    if (!cart) return;
    var body = $('#ac-cartBody'), foot = $('#ac-cartFoot'), rw = $('#ac-rw');
    var ct = $('#ac-cartCt');
    if (ct) ct.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');

    /* reward ladder — measured on the products, excluding gifts and the protection fee */
    var sub = qualifyingSubtotal(cart);
    var ladder = CFG.rewards || [];
    if (rw && CFG.fxUnknown) { rw.style.display = 'none'; ladder = []; }
    if (rw && ladder.length) {
      var next = null;
      for (var i = 0; i < ladder.length; i++) { if (sub < ladder[i].threshold) { next = ladder[i]; break; } }
      var top = ladder[ladder.length - 1].threshold;
      var pct = Math.min(100, (sub / top) * 100);
      var wasOpen = rw.classList.contains('open');
      rw.className = 'ac-rw' + (wasOpen ? ' open' : '');
      var hitCount = ladder.filter(function (r) { return sub >= r.threshold; }).length;
      var prevAt = 0;
      var segments = ladder.map(function (r, i) {
        /* each segment fills independently between its own start and end */
        var span = r.threshold - prevAt;
        var into = Math.min(Math.max(sub - prevAt, 0), span);
        var fill = span > 0 ? (into / span) * 100 : 100;
        prevAt = r.threshold;
        var done = sub >= r.threshold;
        return '<div class="ac-seg ' + (done ? 'done' : '') + '">' +
                 '<span class="sg"><i style="width:' + fill + '%"></i></span>' +
                 '<span class="sy" aria-hidden="true">' + (r.symbol || '★') + '</span>' +
                 '<span class="sa">' + fmt(r.threshold) + '</span>' +
               '</div>';
      }).join('');

      /* Compact by default for EVERY shopper, not just the rare 4-of-4 cart: message,
         thin segmented bar, symbols. The per-tier amounts live in the tap-to-expand
         list below, so the bar costs ~58px instead of ~89px of a phone screen. */
      var allDone = !next;
      if (allDone) rw.className += ' done';

      /* Every tier gets a chip: a tick once it's yours, the amount while it isn't.
         Shoppers asked what they already have, not only what's next. */
      var chips = ladder.map(function (r) {
        var done = sub >= r.threshold;
        return '<span class="ac-chipr' + (done ? ' got' : '') + '">' +
          '<i>' + (r.symbol || '\u2605') + '</i>' +
          '<b>' + esc(r.label) + '</b>' +
          '<u>' + (done ? '\u2713' : fmt(r.threshold)) + '</u></span>';
      }).join('');

      rw.innerHTML =
        '<div class="ac-rl"><div>' +
          (next
            ? 'You\'re <b>' + fmt(next.threshold - sub) + '</b> from ' + esc(next.label.toLowerCase())
            : 'Everything unlocked — nice work') +
        '</div><div class="ac-rt2">' + hitCount + ' / ' + ladder.length + '</div></div>' +
        /* One thin bar for motion; the chips below carry each tier's state, so four
           separate segment tracks were saying the same thing twice. */
        '<div class="ac-bar"><i style="width:' + pct + '%"></i></div>' +
        '<div class="ac-chips2">' + chips + '</div>' +
        '<div class="ac-rwlist">' + ladder.map(function (r) {
          var hit = sub >= r.threshold;
          return '<div class="ac-rwi ' + (hit ? 'hit' : '') + '"><span class="dot">' +
            (hit ? '✓' : (r.symbol || '')) + '</span><span>' + esc(r.label) +
            (r.code && hit ? ' <em class="ac-code">' + esc(r.code) + '</em>' : '') +
            '</span><span class="amt">' + fmt(r.threshold) + '</span></div>';
        }).join('') + '</div>';
    }

    if (!cart.items.length) {
      body.innerHTML = '<div class="ac-empty"><div class="em">\u{1F525}</div>' +
        '<p style="font-size:15px;margin-bottom:16px">Nothing in the cart yet.</p>' +
        '<a class="ac-btn ac-btn--p ac-btn--sm" href="' + CFG.shopAllUrl + '">Browse lighters</a></div>';
      foot.innerHTML = '';
      return;
    }

    var giftIds = {};
    (CFG.gifts || []).forEach(function (g) { if (g.variant) giftIds[g.variant] = g.label; });
    var protId = CFG.protection && CFG.protection.variant;

    var skipIds = {};
    (CFG.gifts || []).forEach(function (g) { if (g.variant) skipIds[g.variant] = true; });
    if (CFG.protection && CFG.protection.variant) skipIds[CFG.protection.variant] = true;
    var addonIds = {};
    (CFG.addons || []).forEach(function (a) { addonIds[a.id] = true; });
    var qualifyingQty = cart.items.reduce(function (n, li) {
      return (skipIds[li.variant_id || li.id] || addonIds[li.product_id]) ? n : n + li.quantity;
    }, 0);
    var nextTier = null;
    (CFG.tiers || []).forEach(function (t) {
      if (qualifyingQty < t.qty && (!nextTier || t.qty < nextTier.qty)) nextTier = t;
    });
    var nudgeShown = false;

    var html = '';
    cart.items.forEach(function (li) {
      if (li.variant_id === protId) return;                       // shown as its own toggle row
      if (giftIds[li.variant_id]) {
        /* One tight line. The subtitle said nothing the word FREE doesn't. */
        html += '<div class="ac-freeline"><div class="fi">' + giftIcon() + '</div>' +
          '<b>' + esc(li.product_title) + '</b><div class="fp">FREE</div></div>';
        return;
      }
      var lineTotal = li.final_line_price;
      var wasTotal = li.original_line_price;
      var tierNudge = '';
      var isAddon = addonIds[li.product_id];
      if (!isAddon && !nudgeShown && nextTier) {
        var need = nextTier.qty - qualifyingQty;
        tierNudge = '<span class="ac-nudge">+' + need + ' more lighter' + (need > 1 ? 's' : '') +
          ' → save ' + nextTier.percent + '%</span>';
        nudgeShown = true;
      }
      var variantLine = li.variant_title && li.variant_title !== 'Default Title' ? esc(li.variant_title) : '';
      html += '<div class="ac-line">' +
        '<div class="lp">' + (li.image ? '<img src="' + li.image + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="li">' +
          '<div class="ln">' + esc(li.product_title) + '</div>' +
          (variantLine ? '<div class="lv">' + variantLine + '</div>' : '') +
          tierNudge +
          /* Stepper, Remove and price share one row — Remove used to sit on a line of
             its own, which cost ~20px on every item in the cart. */
          '<div class="lb"><div class="ac-step">' +
            '<button data-ac-qty="' + li.key + '" data-d="-1" aria-label="Decrease quantity">−</button>' +
            '<span>' + li.quantity + '</span>' +
            '<button data-ac-qty="' + li.key + '" data-d="1" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button class="rm" data-ac-rm="' + li.key + '">Remove</button>' +
          '<div class="lx">' +
            (wasTotal > lineTotal ? '<span class="lwas">' + fmt(wasTotal) + '</span>' : '') +
            '<span class="lpr">' + fmt(lineTotal) + '</span>' +
          '</div></div>' +
        '</div></div>';
    });

    /* upsell rail — products injected by Liquid, minus what's already in the cart */
    var inCart = {};
    cart.items.forEach(function (l) { inCart[l.product_id] = true; });
    var recs = (CFG.upsells || []).filter(function (p) { return !inCart[p.id]; }).slice(0, 6);
    if (recs.length) {
      html += '<details class="ac-crow" open><summary><span style="font-weight:600">Add to your order</span>' +
        '<span style="font-size:12.5px;color:var(--ac-text3);margin-left:6px">one tap</span></summary>' +
        '<div class="ac-cc"><div class="ac-upsells">' + recs.map(function (p) {
          return '<div class="ac-up"><img src="' + p.image + '" alt="" loading="lazy"><div class="ub">' +
            '<div class="un">' + esc(p.title) + '</div><div class="upp">' + fmt(p.price) + '</div>' +
            '<button class="add" data-ac-add="' + p.variant + '">Add</button></div></div>';
        }).join('') + '</div></div></details>';
    }

    /* spares */
    var addons = (CFG.addons || []).filter(function (a) { return !inCart[a.id]; });
    if (addons.length) {
      html += '<details class="ac-crow"><summary><span style="font-weight:600">Wicks, flints &amp; spares</span></summary>' +
        '<div class="ac-cc">' + addons.map(function (a) {
          return '<button class="ac-ao" style="border:0;padding:10px 0;min-height:48px" data-ac-add="' + a.variant + '">' +
            '<span class="ac-ai">' + (a.image ? '<img src="' + a.image + '" alt="">' : giftIcon()) + '</span>' +
            '<span class="ac-an"><b>' + esc(a.title) + '</b><span>' + esc(a.subtitle || '') + '</span></span>' +
            '<span class="ac-ap">' + fmt(a.price) + '</span></button>';
        }).join('') + '</div></details>';
    }

    /* discount code */
    html += '<details class="ac-crow"><summary><span style="font-weight:600">Have a discount code?</span></summary>' +
      '<div class="ac-cc"><div class="ac-codebox">' +
      '<input id="ac-code" placeholder="Enter code" autocomplete="off" aria-label="Discount code">' +
      '<button class="ac-btn ac-btn--s ac-btn--sm" id="ac-codeBtn">Apply</button></div>' +
      '<div style="font-size:12px;color:var(--ac-text3);margin-top:8px">Applied at checkout.</div></div></details>';

    body.innerHTML = html;

    /* Highest unlocked tier that hands out a code — it rides to checkout on the URL. */
    var unlockedCode = null, unlockedLabel = '';
    ladder.forEach(function (r) {
      if (r.code && sub >= r.threshold) { unlockedCode = r.code; unlockedLabel = r.label; }
    });
    var checkoutHref = '/checkout' + (unlockedCode ? '?discount=' + encodeURIComponent(unlockedCode) : '');

    var blocked = checkoutBlock(cart);

    /* Subtotal is shown BEFORE discounts so the discount row isn't double-counted. */
    var gross = cart.original_total_price;
    var savings = gross - cart.total_price;

    /* Shipping protection — pinned just above the totals, like a dedicated cart app.
       If no product is set in Theme settings there is nothing to add, so the row can't
       render; in the theme editor we say so out loud instead of hiding silently. */
    var protRow = '';
    if (protId) {
      var on = protectOn();
      protRow = '<button class="ac-prot" id="ac-protBtn" aria-pressed="' + on + '">' +
        '<span class="ac-ck">' + tickIcon() + '</span>' +
        '<span class="pt">' + esc(CFG.protection.title || 'Shipping protection') + '</span>' +
        '<span class="pp2">' + fmt(CFG.protection.price || 0) + '</span></button>';
    } else if (CFG.designMode) {
      protRow = '<div class="ac-hint">Shipping protection is off because no product is chosen. ' +
        'Theme settings → AllureCart → Shipping protection product. Only you can see this note.</div>';
    }

    var freeShip = sub >= (CFG.freeShipThreshold || 0);
    foot.innerHTML = protRow +
      '<div class="ac-sumline">' +
        '<span>Subtotal ' + fmt(gross) + '</span>' +
        (savings > 0 ? '<span class="sv">Saved ' + fmt(savings) + '</span>' : '') +
        '<span class="' + (freeShip ? 'sv' : '') + '">' +
          (freeShip ? 'Free shipping' : 'Shipping at checkout') + '</span>' +
      '</div>' +
      '<div class="ac-sum tot"><span>Total</span><span class="v">' + fmt(cart.total_price) + '</span></div>' +
      (unlockedCode
        ? '<div class="ac-sum ac-codeline"><span>' + esc(unlockedLabel) +
          '</span><span class="v">at checkout</span></div>'
        : '') +
      (blocked
        ? '<div class="ac-blocked" role="alert">' + esc(blocked) + '</div>' +
          '<button class="ac-btn ac-btn--p ac-btn--blk" disabled>Checkout</button>'
        : '<a class="ac-btn ac-btn--p ac-btn--blk" data-ac-checkout href="' + checkoutHref +
          '">Checkout · ' + fmt(cart.total_price) + '</a>') +
      '<div class="ac-pays"><span>VISA</span><span>MASTERCARD</span><span>AMEX</span><span>PAYPAL</span>' +
        '<span>APPLE PAY</span><span>SHOP PAY</span></div>';
  }

  /* ---------- delegated drawer events ---------- */
  document.addEventListener('click', function (e) {
    var el;

    if ((el = e.target.closest('[data-ac-open-cart]'))) {
      e.preventDefault();
      openDrawer();                                    // on the tap, never after a GET
      /* Only re-read when nothing is pending — otherwise the GET would describe the
         cart as it was before the taps still in flight. */
      if (!wish && !sending) reload();
      return;
    }
    /* Checkout while an update is still in flight. Letting the click through would
       hand Shopify a cart it has not been told about yet — the shopper would arrive at
       a checkout missing the thing they just added. Refusing the click is what left
       the button looking dead. So it waits, says so, and then goes. */
    if ((el = e.target.closest('[data-ac-checkout]'))) {
      if (!wish && !sending) return;                   // nothing pending: ordinary link
      e.preventDefault();
      var fallbackHref = el.getAttribute('href');
      el.textContent = 'One moment…';
      whenSettled(function () {
        /* Re-read the link: the footer has been repainted since, and the href can have
           gained a discount code that the last reply unlocked. */
        var fresh = $('[data-ac-checkout]');
        window.location.href = (fresh && fresh.getAttribute('href')) || fallbackHref;
      });
      return;
    }
    if ((el = e.target.closest('[data-ac-close-cart]'))) { e.preventDefault(); closeDrawer(); return; }
    if (e.target.id === 'ac-scrim') { closeDrawer(); closeChat(); return; }
    if ((el = e.target.closest('#ac-rw'))) { el.classList.toggle('open'); return; }

    /* Each handler works out the cart the shopper just asked for and hands it to
       intend(). Nothing here touches the network — intend() owns that. */

    if ((el = e.target.closest('[data-ac-qty]'))) {
      if (!cart) return;
      var key = el.getAttribute('data-ac-qty');
      var line = cart.items.filter(function (l) { return l.key === key; })[0];
      if (!line) return;
      var q = Math.max(0, line.quantity + Number(el.getAttribute('data-d')));
      intend(predictQty(cart, key, q));
      return;
    }
    if ((el = e.target.closest('[data-ac-rm]'))) {
      if (!cart) return;
      intend(predictQty(cart, el.getAttribute('data-ac-rm'), 0));
      return;
    }
    if ((el = e.target.closest('[data-ac-add]'))) {
      var vid = Number(el.getAttribute('data-ac-add'));
      /* Before the first cart load there is no confirmed state to diff against, so
         absolute quantities would be a guess. Fall back to the plain add. */
      if (!cart || !serverCart) {
        if (busy) return; busy = true;
        el.textContent = 'Adding…';
        addItems([{ id: vid, quantity: 1 }])
          .then(function () { return reload(); })
          .then(function () { busy = false; }, function () { busy = false; });
        return;
      }
      intend(predictAdd(cart, vid, 1),                  // the card leaves the rail at once
             absoluteFor([{ id: vid, quantity: 1 }]));
      return;
    }
    if (e.target.id === 'ac-protBtn' || e.target.closest('#ac-protBtn')) {
      if (!cart) return;
      setProtect(!protectOn());
      /* The row is a checkbox, so it has to tick on the tap. predictAuto adds or drops
         the fee line by the same rule reconcile uses, and it rides along in the same
         request as everything else. */
      intend(cart);
      return;
    }
    if (e.target.id === 'ac-codeBtn') {
      var code = ($('#ac-code').value || '').trim();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + CFG.routes.cart_url;
      return;
    }
  });

  /* ---------- the hero image ----------
     Shopify serves any size of the same photo off one url via ?width=, so a swap
     should rebuild the whole responsive set rather than collapse to one fixed size.
     The first version of this simply stripped srcset before setting src, which meant
     the variant paint on load threw the responsive hero away and pulled a second
     copy of the SAME picture at 1000px — 89 KB wasted on every product page, on top
     of the 70 KB the browser had already chosen correctly. */
  var HERO_SIZES = [400, 600, 800, 1200];
  var HERO_SIZES_ATTR = '(min-width: 900px) 600px, 100vw';
  function widthOf(url, w) { return String(url).replace(/([?&]width=)\d+/, '$1' + w); }
  function baseOf(url) { return String(url).split('?')[0]; }
  function setHero(url) {
    var hero = $('#ac-galMain');
    if (!hero || !url) return;
    /* Same photograph, different size parameter: the hero is already showing it.
       Touching it here is what caused the duplicate download. */
    if (baseOf(hero.currentSrc || hero.src) === baseOf(url)) return;
    if (/[?&]width=\d+/.test(url)) {
      hero.setAttribute('srcset', HERO_SIZES.map(function (w) {
        return widthOf(url, w) + ' ' + w + 'w';
      }).join(', '));
      hero.setAttribute('sizes', HERO_SIZES_ATTR);
      hero.src = widthOf(url, 800);
    } else {
      /* An url with no width parameter can't be resized — one fixed source then. */
      hero.removeAttribute('srcset');
      hero.removeAttribute('sizes');
      hero.src = url;
    }
  }

  /* ---------- product page ---------- */
  function initPDP() {
    var root = $('#ac-pdp'); if (!root) return;
    /* Guarded: a throw in here used to take every product-page click handler with
       it, including both buy buttons and the sticky bar's scroll behaviour. */
    var json = $('#ac-product-json');
    var data = null;
    try { data = json ? JSON.parse(json.textContent) : null; } catch (e) { data = null; }
    if (!data || !data.variants || !data.variants.length) { initStickyBar(); return; }
    var byId = {};
    data.variants.forEach(function (v) { byId[v.id] = v; });

    var gallery = data.images || [];

    /* Shopify only gives a variant its own image if one was assigned there.
       When it wasn't, match on the image's alt text — "007 Silver", "Gold", etc. */
    function imageForVariant(v) {
      if (v.featured_image) return v.featured_image;
      var name = String(v.title).split(' / ')[0].trim().toLowerCase();
      if (!name || name === 'default title') return null;
      var hit = gallery.filter(function (g) {
        return String(g.alt || '').toLowerCase().indexOf(name) !== -1;
      })[0];
      return hit ? hit.url : null;
    }
    function showImage(url) {
      if (!url) return;
      setHero(url);
      $$('[data-ac-thumb]').forEach(function (b) {
        b.setAttribute('aria-current', String(b.getAttribute('data-ac-thumb') === url));
      });
    }

    var first = data.variants.filter(function (v) { return v.available; })[0] || data.variants[0];
    var state = { variant: first, preview: first, qty: 1, units: [first.id], addons: {}, pairs: {} };

    function tierFor(q) {
      var t = null;
      (CFG.tiers || []).forEach(function (x) { if (q >= x.qty) t = x; });
      return t;
    }
    function tierPct() { var t = tierFor(state.qty); return t ? t.percent / 100 : 0; }

    /* keep one entry per unit; new slots inherit the headline finish */
    function syncUnits() {
      while (state.units.length < state.qty) state.units.push(state.variant.id);
      state.units.length = state.qty;
    }
    function unitsSubtotal() {
      return state.units.reduce(function (sum, id) {
        var v = byId[id] || state.variant;
        return sum + Math.round(v.price * (1 - tierPct()));
      }, 0);
    }
    function extrasSubtotal() {
      var sum = 0;
      Object.keys(state.addons).forEach(function (k) { if (state.addons[k]) sum += Number(k.split('|')[1]); });
      Object.keys(state.pairs).forEach(function (k) { if (state.pairs[k]) sum += Number(k.split('|')[1]); });
      return sum;
    }

    /* per-unit finish pickers — only meaningful above quantity 1 */
    function renderMulti() {
      var box = $('#ac-multi'); if (!box) return;
      if (state.qty < 2) { box.hidden = true; box.innerHTML_rows = null; return; }
      box.hidden = false;
      var rows = $('#ac-multiRows'); if (!rows) return;
      rows.innerHTML = state.units.map(function (id, i) {
        return '<div class="ac-mrow"><span class="n">#' + (i + 1) + '</span>' +
          '<select data-ac-unit="' + i + '" aria-label="Finish for item ' + (i + 1) + '">' +
          data.variants.map(function (v) {
            return '<option value="' + v.id + '"' + (v.id === id ? ' selected' : '') +
              (v.available ? '' : ' disabled') + '>' + esc(v.title) +
              (v.available ? '' : ' — sold out') + '</option>';
          }).join('') + '</select></div>';
      }).join('');
    }

    function paint() {
      syncUnits();
      var t = tierFor(state.qty);
      var perUnit = Math.round(state.variant.price * (1 - tierPct()));
      /* Guarded: one missing node used to throw here, which killed every PDP click
         handler on that page — including the buy buttons. */
      var now = $('#ac-nowPrice'); if (now) now.textContent = fmt(perUnit);

      var cmp = $('#ac-cmpPrice');
      if (cmp) {
        var showCmp = state.variant.compare_at_price > state.variant.price;
        cmp.style.display = showCmp ? '' : 'none';
        if (showCmp) cmp.textContent = fmt(state.variant.compare_at_price);
      }
      var badge = $('#ac-saveBadge');
      if (badge) {
        var off = state.variant.compare_at_price > state.variant.price
          ? Math.round((1 - state.variant.price / state.variant.compare_at_price) * 100) : 0;
        var parts = [];
        if (off) parts.push('SAVE ' + off + '%');
        if (t) parts.push('BUNDLE −' + t.percent + '%');
        badge.textContent = parts.join(' + ');
        badge.style.display = parts.length ? '' : 'none';
      }

      $$('[data-ac-variant]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-ac-variant')) === state.variant.id));
      });
      $$('[data-ac-qtytier]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(Number(b.getAttribute('data-ac-qtytier')) === state.qty));
      });

      var lbl = $('#ac-variantLabel');
      if (lbl) {
        var showing = (state.preview || state.variant);
        lbl.textContent = showing.title +
          (showing.id !== state.variant.id ? ' (showing)' : '');
      }
      var qlbl = $('#ac-qtyLabel');
      if (qlbl) {
        var mixed = state.qty > 1 && state.units.some(function (id) { return id !== state.units[0]; });
        qlbl.textContent = state.qty === 1 ? 'Single' : (state.qty + ' pieces' + (mixed ? ' · mixed' : ''));
      }

      renderMulti();

      var grand = unitsSubtotal() + extrasSubtotal();
      var btn = $('#ac-addBtn');
      var anyAvailable = state.units.every(function (id) { return (byId[id] || {}).available; });
      if (btn) {
        btn.disabled = !anyAvailable;
        btn.textContent = anyAvailable ? 'Add to cart · ' + fmt(grand) : 'Sold out';
      }

      var sp = $('#ac-stickyPrice'); if (sp) sp.textContent = fmt(grand);
      var sq = $('#ac-stickyQty');
      if (sq) {
        var extras = Object.keys(state.addons).filter(function (k) { return state.addons[k]; }).length +
                     Object.keys(state.pairs).filter(function (k) { return state.pairs[k]; }).length;
        sq.textContent = (state.qty > 1 ? state.qty + ' pcs' : '1 pc') + (extras ? ' + ' + extras : '');
      }

      showImage(imageForVariant(state.preview || state.variant));
    }

    /* changing a single unit's finish */
    root.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-ac-unit]');
      if (!sel) return;
      var chosen = Number(sel.value);
      state.units[Number(sel.getAttribute('data-ac-unit'))] = chosen;
      /* show what they just picked, so the photo always matches the last choice */
      state.preview = byId[chosen] || state.preview;
      paint();
    });

    /* Bound to the document, not to #ac-pdp: the sticky buy bar is a SIBLING of that
       element, so a click on it never bubbled through here and the button did nothing. */
    document.addEventListener('click', function (e) {
      var el;
      if ((el = e.target.closest('[data-ac-variant]'))) {
        var id = Number(el.getAttribute('data-ac-variant'));
        state.variant = byId[id] || state.variant;
        state.preview = state.variant;
        state.units = state.units.map(function () { return state.variant.id; });   // headline choice resets all
        paint(); return;
      }
      if ((el = e.target.closest('[data-ac-qtytier]'))) {
        state.qty = Number(el.getAttribute('data-ac-qtytier'));
        state.preview = state.variant;
        paint(); return;
      }
      if ((el = e.target.closest('[data-ac-addon]'))) {
        var k = el.getAttribute('data-ac-addon');
        state.addons[k] = !state.addons[k];
        el.setAttribute('aria-pressed', String(!!state.addons[k])); paint(); return;
      }
      if ((el = e.target.closest('[data-ac-pair]'))) {
        var pk = el.getAttribute('data-ac-pair');
        state.pairs[pk] = !state.pairs[pk];
        el.setAttribute('aria-pressed', String(!!state.pairs[pk])); paint(); return;
      }
      if ((el = e.target.closest('[data-ac-thumb]'))) {
        setHero(el.getAttribute('data-ac-thumb'));
        $$('[data-ac-thumb]').forEach(function (b) { b.setAttribute('aria-current', String(b === el)); });
        return;
      }
      if (e.target.closest('#ac-addBtn') || e.target.closest('#ac-stickyAdd')) {
        if (busy) return; busy = true;
        var srcBtn = e.target.closest('#ac-addBtn') || e.target.closest('#ac-stickyAdd');
        var srcLabel = srcBtn.textContent;
        srcBtn.textContent = 'Adding…';
        var restore = function () { srcBtn.textContent = srcLabel; };

        /* group the chosen units so 2 × Silver is one line, Silver + Gold is two */
        var counts = {};
        state.units.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
        var items = Object.keys(counts).map(function (id) {
          return { id: Number(id), quantity: counts[id] };
        });
        Object.keys(state.addons).forEach(function (k) { if (state.addons[k]) items.push({ id: Number(k.split('|')[0]), quantity: 1 }); });
        Object.keys(state.pairs).forEach(function (k) { if (state.pairs[k]) items.push({ id: Number(k.split('|')[0]), quantity: 1 }); });

        openDrawer();                                // on the tap, before any network

        /* Opening the drawer instantly onto the OLD cart was the worst of both: the
           panel appeared at once and then sat there showing the wrong thing. Predict
           the lines from the variant data already on the page, so the drawer opens
           with the lighter they just added already in it. */
        var clear = function () {
          state.addons = {}; state.pairs = {};
          $$('[data-ac-addon],[data-ac-pair]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          paint();                                   // paint() rewrites #ac-addBtn's own label
          if (srcBtn.id === 'ac-stickyAdd') restore();
        };

        /* No confirmed cart to diff against yet — send the plain add and read back. */
        if (!cart || !serverCart) {
          addItems(items).then(function (res) {
            if (res && res.status && res.description) {
              toast(res.description); restore(); closeDrawer(); busy = false; return;
            }
            clear();
            return reload().then(function () { busy = false; });
          }, function () { restore(); busy = false; reload(); });
          return;
        }

        var pred = cart;
        items.forEach(function (it) {
          var v = byId[it.id];
          pred = predictAdd(pred, it.id, it.quantity, v ? {
            pid: data.id,
            title: (window.ACProduct && window.ACProduct.title) || v.title || '',
            price: v.price,
            image: imageForVariant(v) || (gallery[0] && gallery[0].url) || null,
            variantTitle: v.title && v.title !== 'Default Title' ? v.title : null
          } : null);
        });
        clear();
        intend(pred, absoluteFor(items))
          .then(function () { busy = false; }, function () { busy = false; });
        return;
      }
    });

    initStickyBar();
    paint();
  }

  /* When the sticky buy bar is allowed to appear.
     It used to be "420 pixels scrolled", which on a tall product page fired while
     the real Add to cart button was still well below the fold — so the page had a
     floating bar covering things before the shopper had seen anything. Two rules
     now, and BOTH have to be true:
       1. past 60% of the page, and
       2. the real Add to cart button has scrolled out of view.
     Rule 2 means the bar never duplicates a button you can already press, and on a
     short page where the button stays on screen the bar simply never appears. */
  function initStickyBar() {
    var sticky = $('#ac-sticky');
    if (!sticky) return;
    var mainBtn = $('#ac-addBtn');
    var at = typeof CFG.stickyAfter === 'number' ? CFG.stickyAfter : 0.6;

    var onScroll = function () {
      var doc = document.documentElement;
      var scrollable = Math.max(1, (doc.scrollHeight || 0) - window.innerHeight);
      var pastPoint = (window.scrollY / scrollable) >= at;

      var buttonGone = true;
      if (mainBtn) {
        var r = mainBtn.getBoundingClientRect();
        buttonGone = r.bottom <= 0 || r.top >= window.innerHeight;
      }

      var show = pastPoint && buttonGone;
      sticky.classList.toggle('on', show);
      document.documentElement.classList.toggle('ac-buybar', show);
      var cb = $('#ac-chatBtn');
      if (cb) cb.classList.toggle('hide', show && window.innerWidth < 900);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- rewards modal ---------- */
  var rwTab = 'earn';
  function icon(name) {
    var p = {
      join: '<path d="M12 3l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.4 6.8 19.1l1-5.8L3.5 9.2l5.9-.9z"/>',
      order: '<path d="M5.5 8h13l-1.2 11.2a2 2 0 01-2 1.8H8.7a2 2 0 01-2-1.8z"/><path d="M9 8V6.2a3 3 0 116 0V8"/>',
      social: '<rect x="4" y="4" width="16" height="16" rx="4.5"/><circle cx="12" cy="12" r="3.4"/><circle cx="17" cy="7" r="1"/>',
      tiktok: '<path d="M14 4v9.6a3.4 3.4 0 11-2.6-3.3"/><path d="M14 4c.4 2.3 1.9 3.7 4.2 3.9"/>',
      review: '<path d="M12 3l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.4 6.8 19.1l1-5.8L3.5 9.2l5.9-.9z"/>',
      cake: '<path d="M4 20h16v-6H4z"/><path d="M4 14c2 0 2-1.5 4-1.5S10 14 12 14s2-1.5 4-1.5S18 14 20 14"/><path d="M12 9V5"/>',
      money: '<rect x="3" y="7" width="18" height="10" rx="2"/><circle cx="12" cy="12" r="2.5"/>',
      gift: '<rect x="3.5" y="8.5" width="17" height="12" rx="1.5"/><path d="M3.5 12.5h17M12 8.5v12"/>',
      truck: '<path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.8"/><circle cx="17.5" cy="18" r="1.8"/>'
    };
    return '<svg viewBox="0 0 24 24">' + (p[name] || p.join) + '</svg>';
  }

  /* The popup's content comes from the "Popup — rewards or email" section in the
     footer group, so every word of it is editable in the theme editor. Theme
     settings are only a fallback for a theme that predates that section. */
  function pop() {
    /* No section means no popup — removing it from the footer group is how you turn it off. */
    return window.ACRewards && window.ACRewards.mode ? window.ACRewards : { mode: 'off', launchers: false };
  }
  function openRewards(tab, forceSuccess) {
    var R = pop();
    if (R.mode === 'off' && !R.designMode) return;
    rwTab = tab || 'earn';
    var m = $('#ac-modal');
    var joined = forceSuccess === true;
    if (!joined) { try { joined = localStorage.getItem('ac_member') === '1'; } catch (e) {} }

    var head = joined
      ? '<h3 class="ac-disp" style="margin-top:6px">' + esc(R.successHeading || "You're in") + '</h3>' +
        '<p class="ac-sp">' + esc(R.successBody || '') + '</p>' +
        (R.code
          ? '<button class="ac-codechip" id="ac-copyCode" data-code="' + esc(R.code) + '">' +
            '<span class="cl">Your code</span><b>' + esc(R.code) + '</b><span class="cc">Tap to copy</span></button>'
          : '')
      : '<h3 class="ac-disp" style="margin-top:6px">' + esc(R.heading || '') +
          (R.accent ? ' <em>' + esc(R.accent) + '</em>' : '') + '</h3>' +
        '<p class="ac-sp">' + esc(R.body || '') + '</p>' +
        '<form id="ac-joinForm" method="post" action="/contact#ac-join" accept-charset="UTF-8">' +
        '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="contact[tags]" value="' + esc(R.tags || 'newsletter') + '">' +
        '<input type="email" name="contact[email]" required placeholder="your@email.com" autocomplete="email">' +
        '<button class="ac-btn ac-btn--p ac-btn--blk" type="submit">' + esc(R.buttonLabel || 'Sign up') + '</button>' +
        '</form>' +
        (R.footnote ? '<p class="ac-fine">' + esc(R.footnote) + '</p>' : '') +
        '<button class="ac-skip" data-ac-close-modal>' + esc(R.declineLabel || 'No thanks') + '</button>';

    /* The tabs, points and tiers are the rewards programme. Email mode is just the offer. */
    var body = '';
    if (R.mode === 'rewards') {
      var L = R.tabLabels || {};
      body = '<div class="ac-rwtabs" role="tablist" style="margin-top:' + (joined ? '4px' : '20px') + '">' +
        ['earn', 'vip', 'ref'].map(function (t) {
          var lbl = t === 'earn' ? (L.earn || 'Ways to earn') : t === 'vip' ? (L.vip || 'VIP tiers') : (L.ref || 'Refer');
          return '<button role="tab" aria-selected="' + (rwTab === t) + '" data-ac-rwtab="' + t + '">' + esc(lbl) + '</button>';
        }).join('') + '</div>' +
        (rwTab === 'earn'
          ? (R.earn || []).map(function (x) {
              return '<div class="ac-earn"><span class="ei">' + icon(x.icon) + '</span>' +
                '<span class="en"><b>' + esc(x.name) + '</b><span>' + esc(x.note) + '</span></span>' +
                '<span class="ep">' + esc(x.points) + '</span></div>';
            }).join('')
          : rwTab === 'vip'
          ? (R.vip || []).map(function (t) {
              return '<div class="ac-vip ' + (t.gold ? 'gold' : '') + '"><div class="vh">' +
                '<span class="vn">' + esc(t.name) + '</span><span class="vp">' + esc(t.at) + '</span></div><ul>' +
                (t.perks || []).map(function (p) { return '<li>' + esc(p) + '</li>'; }).join('') + '</ul></div>';
            }).join('')
          : '<div class="ac-vip"><div class="vh"><span class="vn">' + esc(R.referTitle || '') +
            '</span></div><ul>' + (R.refer || []).map(function (p) { return '<li>' + esc(p) + '</li>'; }).join('') +
            '</ul></div>');
    }

    var editorNote = (R.mode === 'off' && R.designMode)
      ? '<div class="ac-hint" style="margin:14px 0 0">The popup is switched off, so shoppers never see this. ' +
        'Turn it back on under Footer, in the section called Popup — rewards or email.</div>' : '';

    m.innerHTML = '<div class="ac-sheet"><button class="x" data-ac-close-modal aria-label="Close">✕</button>' +
      (R.image ? '<div class="ac-shero"><img src="' + R.image + '" alt=""></div>' : '') +
      '<div class="ac-sb">' + (R.eyebrow ? '<div class="ac-eyebrow">' + esc(R.eyebrow) + '</div>' : '') +
      head + body + editorNote + '</div></div>';
    m.classList.add('on');
    syncScrollLock();
    var f = $('#ac-joinForm');
    if (f) f.addEventListener('submit', function () { try { localStorage.setItem('ac_member', '1'); } catch (e) {} });
  }
  function closeModal() {
    setOn('#ac-modal', false);
    syncScrollLock();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ac-rewards]')) { e.preventDefault(); openRewards(); return; }
    if (e.target.closest('[data-ac-close-modal]')) { e.preventDefault(); closeModal(); return; }
    var cc = e.target.closest('#ac-copyCode');
    if (cc) {
      e.preventDefault();
      var code = cc.getAttribute('data-code') || '';
      var done = function () { var s = cc.querySelector('.cc'); if (s) s.textContent = 'Copied'; };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else {
        var ta = document.createElement('textarea');
        ta.value = code; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (err) {}
        document.body.removeChild(ta); done();
      }
      return;
    }
    var t = e.target.closest('[data-ac-rwtab]');
    if (t) { openRewards(t.getAttribute('data-ac-rwtab')); return; }
    if (e.target.id === 'ac-modal') closeModal();
  });

  /* ---------- concierge chat ---------- */
  var chatCtx = null;
  function openChat() {
    chatCtx = window.ACProduct || null;
    setOn('#ac-chat', true);
    setOn('#ac-scrim', true);
    var b = $('#ac-chatBody'); b.innerHTML = '';
    /* Deliberately no product description here: it pasted raw HTML, images went
       missing and left holes. The page already carries the description; this panel
       answers the handful of questions the page doesn't. */
    say('bot', 'Hi — quick answers on delivery, returns, fuel and bundles. Pick one.');
    chips();
  }
  function closeChat() {
    setOn('#ac-chat', false);
    if (!drawerOpen()) setOn('#ac-scrim', false);
    syncScrollLock();
  }
  function say(who, text) {
    var b = $('#ac-chatBody');
    var d = document.createElement('div');
    d.className = 'ac-msg ' + who;
    d.textContent = text;
    b.appendChild(d);
    b.scrollTop = b.scrollHeight;
  }
  function chips() {
    var c = $('#ac-chatChips');
    /* Every chip maps to an answer you wrote in Theme settings, so none of them can
       fall through to "email us" — which is what the old weight question did. */
    var base = [['Delivery time?', 'shipping'], ['Returns?', 'returns'],
                ['Does it come with fuel?', 'fuel'], ['Bundle deal?', 'bundle'],
                ['What\'s your bestseller?', 'best']];
    c.innerHTML = base.map(function (x) {
      return '<button class="ac-chip" data-ac-ask="' + x[1] + '">' + x[0] + '</button>';
    }).join('');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ac-chat]')) { e.preventDefault(); openChat(); return; }
    if (e.target.closest('[data-ac-close-chat]')) { e.preventDefault(); closeChat(); return; }
    var a = e.target.closest('[data-ac-ask]');
    if (!a) return;
    var key = a.getAttribute('data-ac-ask');
    say('me', a.textContent);
    setTimeout(function () {
      var ans = (CFG.chatAnswers || {})[key];
      say('bot', ans || 'Email ' + (CFG.supportEmail || 'us') + ' and a human will answer within the hour.');
    }, 380);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeChat(); closeModal(); }
  });

  /* Dawn's standalone /cart page has its own checkout button — hold it to the same rule. */
  function gateCartPage() {
    if (!cart) return;
    var msg = checkoutBlock(cart);
    $$('[name="checkout"], .cart__checkout-button').forEach(function (btn) {
      btn.disabled = !!msg;
      btn.setAttribute('aria-disabled', String(!!msg));
      var note = btn.parentNode && btn.parentNode.querySelector('.ac-blocked');
      if (msg && !note) {
        note = document.createElement('div');
        note.className = 'ac-blocked';
        btn.parentNode.insertBefore(note, btn);
      }
      if (note) { note.textContent = msg || ''; note.style.display = msg ? '' : 'none'; }
    });

    /* Shop Pay, Apple Pay, PayPal and Google Pay sit in Shopify's own dynamic
       checkout block. They skip the button above entirely and go straight to
       checkout, so disabling that button alone left the rule wide open. They are
       third-party widgets rendered in shadow roots and iframes, and `disabled`
       does not reach inside one — hiding the whole block is what actually holds. */
    $$('.cart__dynamic-checkout-buttons, .additional-checkout-buttons, ' +
       '[data-shopify="dynamic-checkout-cart"], [data-shopify="payment-button"]')
      .forEach(function (box) {
        box.style.display = msg ? 'none' : '';
        box.setAttribute('aria-hidden', String(!!msg));
      });
  }

  /* Keep the bottom-pinned bars on the edge the shopper can actually see.
     Phone browsers report a layout viewport that assumes their toolbar is hidden,
     so bottom:0 sat under the toolbar and left a dead strip. The Visual Viewport
     API says how much is covered right now; that number becomes --ac-vvb. */
  function initViewportPin() {
    var root = document.documentElement;
    var vv = window.visualViewport;
    if (!vv) return;                      // older browsers keep the plain bottom:0

    var apply = function () {
      var covered = root.clientHeight - (vv.height + vv.offsetTop);
      /* An on-screen keyboard also shrinks the visual viewport. Cap the shift so a
         keyboard can never throw the bars into the middle of the screen. */
      if (!isFinite(covered) || covered < 0) covered = 0;
      if (covered > 140) covered = 0;
      root.style.setProperty('--ac-vvb', Math.round(covered) + 'px');
      root.classList.toggle('ac-browserchrome', covered > 4);
    };

    vv.addEventListener('resize', apply);
    vv.addEventListener('scroll', apply);
    window.addEventListener('orientationchange', apply);
    apply();
  }

  /* ---------- boot ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    initViewportPin();
    localiseConfig();                  // must run before anything reads a threshold

    /* Transparent header only stays transparent over the hero; once you scroll it
       needs its background back or the links sit on top of product photos. */
    var head = $('.ac-head--transparent');
    if (head) {
      var onHead = function () { head.classList.toggle('is-scrolled', window.scrollY > 40); };
      window.addEventListener('scroll', onHead, { passive: true });
      onHead();
    }
    initPDP();
    refresh().then(gateCartPage);
    var R = pop();

    /* Launcher buttons take their wording from the same section, and disappear with it. */
    $$('[data-ac-rewards]').forEach(function (b) {
      if (!R.launchers || R.mode === 'off') { b.style.display = 'none'; return; }
      var s = b.querySelector('span');
      if (s && R.launcherLabel) s.textContent = R.launcherLabel;
      if (b.classList.contains('ac-ico')) b.setAttribute('aria-label', R.launcherLabel || 'Rewards');
      else if (!s && R.launcherLabel) {
        /* tab-bar button: the label is a bare text node after the icon */
        var n = b.lastChild;
        if (n && n.nodeType === 3) n.nodeValue = R.launcherLabel.toUpperCase();
      }
    });

    /* Shopify posts the signup form and reloads with customer_posted=true.
       That's our only chance to show the code, so reopen straight into success. */
    if (location.search.indexOf('customer_posted=true') > -1) {
      try { localStorage.setItem('ac_member', '1'); localStorage.setItem('ac_rw', '1'); } catch (e) {}
      openRewards('earn', true);
    }

    var delay = Number(R.delay || 0);
    if (delay > 0 && R.mode !== 'off') {
      setTimeout(function () {
        var seen = false, member = false;
        try { seen = localStorage.getItem('ac_rw') === '1'; member = localStorage.getItem('ac_member') === '1'; } catch (e) {}
        if (!seen && !member && !drawerOpen() && !isOn('#ac-modal')) {
          openRewards();
          try { localStorage.setItem('ac_rw', '1'); } catch (e) {}
        }
      }, delay * 1000);
    }
  });

  window.AllureCart = { refresh: refresh, openCart: function () { refresh(true); }, openRewards: openRewards, openChat: openChat };
})();